import { ComponentRef } from '@angular/core';
import { Subject } from 'rxjs';
import { SdvorModalComponent } from './modal.component';

export class SdModal {
  modalRef: ComponentRef<SdvorModalComponent>;
  contentRef: ComponentRef<any>;
  closed$ = new Subject<void>();

  onClose: (result: any) => any;

  close(result?: any): void {
    this.onClose?.(result);
    this.closed$.next();
    this.closed$.complete();
  }

  setOnCloseMethod<T>(fn: (result: T) => any): void {
    this.onClose = fn;
  }

  setContentRef(contentRef: ComponentRef<any>): void {
    this.contentRef = contentRef;
  }

  setModalRef(modalRef: ComponentRef<SdvorModalComponent>): void {
    this.modalRef = modalRef;
  }
}
